<template>
  <div class="dummy-chart">
    <v-chart :options="chartOptions" style="width: 600px; height: 600px; background-color: #0aa0ff" />
    <line-chart :data-option="chartOptions"/>
  </div>
</template>

<script>
import { use } from 'echarts/core'
import { CandlestickChart } from 'echarts/charts'
import { GridComponent, TooltipComponent, DataZoomComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import VChart, { THEME_KEY } from "vue-echarts";
import {THE_GRAPH_API} from "@/config";
import LineChart from "@/views/account/modules/lineChart.vue";

use([
  CandlestickChart,
  GridComponent,
  TooltipComponent,
  DataZoomComponent,
  CanvasRenderer,
])

export default {
  name: 'candleChart',
  components: {
    LineChart,
    'v-chart': VChart
  },
  data() {
    return {
      chartOptions: {
        title: {
          text: "1233321",
          textStyle: {
            fontWeight: "normal",
            fontSize: 12,
            color: "#999",
          },
          top: "5px",
          left: "10px",
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            if (!params || !params.length) return '';
            // Using the first series' data
            const data = params[0].data;
            return `Open: ${data[0]}<br/>Close: ${data[1]}<br/>Low: ${data[2]}<br/>High: ${data[3]}`;
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          top: '15%',
          bottom: '15%'
        },
        xAxis: {
          type: 'category',
          data: ['2021-01-01', '2021-01-02', '2021-01-03', '2021-01-04']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          type: 'candlestick',
          data: [
            [2200, 2300, 2100, 2350],
            [2300, 2320, 2280, 2380],
            [2320, 2300, 2260, 2360],
            [2300, 2340, 2290, 2400]
          ]
        }]
      }
    }
  }
}
</script>

<style scoped>
.dummy-chart {
  z-index: 100;
  background-color: #9D50BB;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>